// removed by extract-text-webpack-plugin
module.exports = {"chartCard":"antd-pro-charts--chart-card-chartCard","meta":"antd-pro-charts--chart-card-meta","action":"antd-pro-charts--chart-card-action","total":"antd-pro-charts--chart-card-total","content":"antd-pro-charts--chart-card-content","contentFixed":"antd-pro-charts--chart-card-contentFixed","footer":"antd-pro-charts--chart-card-footer"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/ChartCard/index.less
// module id = 847
// module chunks = 0